import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=2bbbd078&scoped=true&"
import script from "./projectList.vue?vue&type=script&lang=js&"
export * from "./projectList.vue?vue&type=script&lang=js&"
import style1 from "./projectList.vue?vue&type=style&index=1&id=2bbbd078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbd078",
  null
  
)

export default component.exports